interface MainTagProp {
  children: any;
}

function MainTag({ children }: MainTagProp) {
  //   console.log(children);
  //   console.log(builderBlock);
  return (
    <main className="tw-w-full tw-flex tw-flex-col tw-justify-between !tw-max-h-fit tw-font-[Avenir]">{children}</main>
  );
}

export default MainTag;
